import React, { useEffect, useRef, useState } from 'react';
import { mapStyleSheet } from './mapStyleSheet';
import { Text, Button } from '@chakra-ui/react';
import { MdLocationPin } from 'react-icons/md';

interface MapCoordinates {
 latitude: number | null;
 longitude: number | null
}

interface MapPickerProps {
  onLocationSelect: (latitude: number, longitude: number) => void;
  initialLatitude: number;
  initialLongitude: number;
  autoLocateDevice: () => void;
  mapCoordinates: MapCoordinates;
}

const MapPicker: React.FC<MapPickerProps> = ({ onLocationSelect, initialLatitude, initialLongitude, autoLocateDevice, mapCoordinates }) => {
  const mapRef = useRef<HTMLDivElement | null>(null);
  const [map, setMap] = useState<google.maps.Map | null>(null);
  const [marker, setMarker] = useState<google.maps.Marker | null>(null);
  const [jumpToLocation, setJumpToLocation] = useState(false)

  useEffect(() => {
    if (!mapRef.current) return;

    const initialPosition = { lat: initialLatitude, lng: initialLongitude };

    // Initialize the map
    const map = new google.maps.Map(mapRef.current, {
      center: initialPosition,
      zoom: 15,
      styles: mapStyleSheet
    });

    // Initialize a draggable marker
    const marker = new google.maps.Marker({
      position: initialPosition,
      map,
      draggable: true,
    });

    // Set the map and marker in the state
    setMap(map);
    setMarker(marker);

    // Add an event listener to update the marker position
    marker.addListener('dragend', () => {
      const position = marker.getPosition() || new google.maps.LatLng(0, 0);
      onLocationSelect(
        position.lat(),
        position.lng(),
      );
    });

    return () => {
      // Clean up the map and marker when the component unmounts
      //if (map) map.setMap(null);
      if (marker) marker.setMap(null);
    };
  }, [onLocationSelect]);

  useEffect(() => {
    // Check if mapCoordinates are different from initial coordinates and update map
    if (map && marker && (mapCoordinates.latitude !== null && mapCoordinates.longitude !== null)) {
      const newPosition = { lat: mapCoordinates.latitude!, lng: mapCoordinates.longitude! };
      const currentMarkerPosition = marker.getPosition();
      if (jumpToLocation && currentMarkerPosition && (currentMarkerPosition.lat() !== mapCoordinates.latitude || currentMarkerPosition.lng() !== mapCoordinates.longitude)) {
        marker.setPosition(newPosition);
        map.setCenter(newPosition);
        setJumpToLocation(false)
      }
    }
  }, [map, marker, mapCoordinates]);

  return (
    <>
    <Text textAlign={'center'}>
      <Button leftIcon={<MdLocationPin />} m={2} borderRadius={'full'} onClick={() => {
          autoLocateDevice()
          setJumpToLocation(true)
        }}>
        Locate Me
      </Button>
    </Text>
    <Text textAlign={'center'} mb={2}>You can also drag the pin to your delivery location.</Text>
    <div>
      <div
        ref={mapRef}
        style={{ width: '100%', height: '400px', border: '1px solid #ccc' }}
      />
    </div>
    </>
  );
};

export default MapPicker;
